// extracted by mini-css-extract-plugin
export default {"map":"FvTq9H0ZJ6","click":"WiA7y2-C-s","container":"kHmyaUX3hM","widget":"_2TtrLBPpOu"};
    if(module.hot) {
      // 1643570446958
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  